@if (type() === 'textarea') {
  <textarea
    rows="1"
    [formControl]="control()"
    [ngClass]="labelClasses"
    [placeholder]="placeholder() | translate"></textarea>
}
@if (type() === 'input') {
  <input
    pInputText
    class="w-full"
    [attr.mode]="mode()"
    [attr.animated]="animated()"
    [ngClass]="labelClasses"
    [formControl]="control()"
    [placeholder]="placeholder() | translate"
    (input)="onInput()" />
}

@if (control().invalid && control().dirty) {
  <!-- <button (click)="onCancel()">RESET</button> -->
}
